import { init } from "@rematch/core";
import models from "./models";

const store = init({ models });

export type KoreDispatch = typeof store.dispatch;
export default store;
